import slugify from "slugify";

const truncate = (input, maxLength = 50) => {
  if (input.length <= maxLength) {
    return input;
  }

  const trimmedString = input.slice(0, maxLength);
  return trimmedString.slice(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
};

export const getSlugForSolution = ({ title = "", id = "" } = {}) => `${slugify(truncate(title))}-${id}`;

export const getIdFromSolutionSlug = (slug = "") => slug.slice(slug.lastIndexOf("-") + 1);
